export default __webpack_public_path__ + "static/media/TRADE-TECH-IMG.08027fb3.gif";